"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _pickers = require("@material-ui/pickers");
var _dateFns = _interopRequireDefault(require("@date-io/date-fns"));
var _ptBR = _interopRequireDefault(require("date-fns/locale/pt-BR"));
var _ArrowBackIos = _interopRequireDefault(require("@material-ui/icons/ArrowBackIos"));
var _ArrowForwardIos = _interopRequireDefault(require("@material-ui/icons/ArrowForwardIos"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _SttHeading = _interopRequireDefault(require("../SttTypography/SttHeading"));
var _SttText = _interopRequireDefault(require("../SttTypography/SttText"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _fonteAzul, _fonte;
  return {
    header: _defineProperty({
      backgroundColor: '#0A6FB8',
      color: '#fff',
      padding: theme.spacing(0.8),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderTopLeftRadius: 17,
      borderTopRightRadius: 17,
      boxShadow: '-5px -5px 15px rgba(255, 255, 255, 0.15), 5px 5px 15px rgba(0, 0, 0, 0.35)',
      minHeight: '40px'
    }, theme.breakpoints.down('xs'), {
      minHeight: '30px'
    }),
    conteudoDoComponente: {
      backgroundColor: '#fff',
      height: '100%',
      padding: theme.spacing(2),
      borderBottomLeftRadius: 17,
      borderBottomRightRadius: 17,
      boxShadow: '-5px -5px 15px rgba(255, 255, 255, 0.15), 5px 5px 15px rgba(0, 0, 0, 0.35)'
    },
    displayDaData: _defineProperty({
      textAlign: 'center',
      fontWeight: 'bold',
      cursor: 'pointer',
      flexGrow: 1
    }, theme.breakpoints.down('xs'), {
      fontSize: '0.9em'
    }),
    conteudo: _defineProperty({}, theme.breakpoints.down('xs'), {
      marginLeft: '0',
      alignItems: 'center',
      justifyContent: 'center'
    }),
    fonteAzul: (_fonteAzul = {}, _defineProperty(_fonteAzul, theme.breakpoints.down('xs'), {
      fontSize: '0.9em'
    }), _defineProperty(_fonteAzul, "display", 'flex'), _defineProperty(_fonteAzul, "justifyContent", 'space-between'), _defineProperty(_fonteAzul, "fontWeight", 'bold'), _defineProperty(_fonteAzul, "color", '#1274B9'), _defineProperty(_fonteAzul, "marginBottom", theme.spacing(1.5)), _fonteAzul),
    fonte: (_fonte = {}, _defineProperty(_fonte, theme.breakpoints.down('xs'), {
      fontSize: '0.85em',
      marginLeft: '3vw'
    }), _defineProperty(_fonte, theme.breakpoints.down('md'), {
      fontSize: '0.85em',
      marginLeft: '1.5vw'
    }), _defineProperty(_fonte, "display", 'flex'), _defineProperty(_fonte, "justifyContent", 'space-between'), _defineProperty(_fonte, "marginLeft", '1.3vw'), _defineProperty(_fonte, "maxWidth", '100%'), _defineProperty(_fonte, "marginBottom", theme.spacing(1.5)), _fonte),
    IconButton: {
      fontSize: 'small'
    }
  };
});
var capitalizeFirstLetter = function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
};
var SttProdutividadeLaudo = function SttProdutividadeLaudo(_ref) {
  var semLaudo = _ref.semLaudo,
    direcionados = _ref.direcionados,
    laudados = _ref.laudados,
    semana = _ref.semana,
    onDateChange = _ref.onDateChange,
    hasButton = _ref.hasButton;
  var classes = useStyles();
  var now = new Date();
  var lastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  var atualMonth = new Date(now.getFullYear(), now.getMonth(), 1);
  var _useState = (0, _react.useState)(function () {
      return hasButton ? lastMonth : atualMonth;
    }),
    _useState2 = _slicedToArray(_useState, 2),
    data = _useState2[0],
    setData = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    abrirPicker = _useState4[0],
    setAbrirPicker = _useState4[1];
  var handleDateChange = function handleDateChange(date) {
    var mes = date.getMonth() + 1;
    var ano = date.getFullYear();
    setData(date);
    onDateChange({
      mes: mes,
      ano: ano
    });
  };
  var formatarData = function formatarData(date) {
    return capitalizeFirstLetter((0, _format["default"])(date, 'MMMM yyyy', {
      locale: _ptBR["default"]
    }));
  };
  var dataAnterior = function dataAnterior() {
    var newDate = new Date(data);
    newDate.setMonth(data.getMonth() - 1);
    setData(newDate);
    onDateChange({
      mes: newDate.getMonth() + 1,
      ano: newDate.getFullYear()
    });
  };
  var dataProximo = function dataProximo() {
    var newDate = new Date(data);
    newDate.setMonth(data.getMonth() + 1);
    setData(newDate);
    onDateChange({
      mes: newDate.getMonth() + 1,
      ano: newDate.getFullYear()
    });
  };
  var proximoMesSemBotao = function proximoMesSemBotao() {
    return data.getMonth() === now.getMonth() - 1 && data.getFullYear() === now.getFullYear();
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.header
  }, hasButton && /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
    onClick: dataAnterior,
    color: "inherit"
  }, /*#__PURE__*/_react["default"].createElement(_ArrowBackIos["default"], {
    className: classes.IconButton
  })), /*#__PURE__*/_react["default"].createElement(_SttHeading["default"], {
    className: classes.displayDaData,
    gutterBottom: true,
    variant: "h5",
    onClick: function onClick() {
      return setAbrirPicker(true);
    }
  }, formatarData(data)), hasButton && /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
    onClick: dataProximo,
    color: "inherit",
    disabled: proximoMesSemBotao()
  }, /*#__PURE__*/_react["default"].createElement(_ArrowForwardIos["default"], {
    className: classes.IconButton
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.conteudoDoComponente
  }, hasButton && /*#__PURE__*/_react["default"].createElement(_pickers.MuiPickersUtilsProvider, {
    utils: _dateFns["default"],
    locale: _ptBR["default"]
  }, /*#__PURE__*/_react["default"].createElement(_pickers.KeyboardDatePicker, {
    margin: "normal",
    open: abrirPicker,
    onOpen: function onOpen() {
      return setAbrirPicker(true);
    },
    onClose: function onClose() {
      return setAbrirPicker(false);
    },
    views: ['year', 'month'],
    variant: "dialog",
    format: "MM/yyyy",
    value: data,
    onChange: handleDateChange,
    maxDate: lastMonth,
    KeyboardButtonProps: {
      'aria-label': 'change date'
    },
    style: {
      display: 'none'
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.conteudo
  }, /*#__PURE__*/_react["default"].createElement(_SttText["default"], {
    className: classes.fonteAzul
  }, "Sem laudo: ", /*#__PURE__*/_react["default"].createElement("span", null, semLaudo)), /*#__PURE__*/_react["default"].createElement(_SttText["default"], {
    className: classes.fonte
  }, "Direcionados: ", /*#__PURE__*/_react["default"].createElement("span", {
    className: classes.numeros
  }, direcionados)), /*#__PURE__*/_react["default"].createElement(_SttText["default"], {
    className: classes.fonteAzul
  }, "Laudado: ", /*#__PURE__*/_react["default"].createElement("span", null, laudados)), semana >= 0 && /*#__PURE__*/_react["default"].createElement(_SttText["default"], {
    className: classes.fonte
  }, "Na semana: ", /*#__PURE__*/_react["default"].createElement("span", null, semana)))));
};
var _default = SttProdutividadeLaudo;
exports["default"] = _default;